import { Button } from '../../atoms/Button';
import { Icon } from '../../atoms/Icon';
import { Typography } from '../../molecules/Typography';

interface IFreemiumLockContent {
  className?: string;
  title?: string;
  description?: string;
  showButton?: boolean;
}

export default function FreemiumLockContent({
  className = '',
  title = 'Conteúdo exclusivo para assinantes',
  description = 'Assine e tenha acesso completo à plataforma que mais aprova no país.',
  showButton = true,
}: IFreemiumLockContent) {
  const handleCheckout = () => {
    // TODO: redirecionar para o checkout de pagamento
  };

  return (
    <div
      className={`m-auto flex w-full flex-col items-center gap-lg rounded-[16px] bg-color-lightest px-6 py-8 text-center shadow-level-1 ${className}`}
    >
      <div className='rounded-full bg-brand-color-secondary-lightest flex h-16 w-16 items-center justify-center'>
        <Icon
          id='freemium-lock-icon'
          Icon='lock'
          variant='rounded'
          type='material'
          className='filled text-4xl text-brand-color-secondary-pure'
        />
      </div>

      <div className='flex flex-col gap-sm'>
        <Typography type='title' size='h4' weight='bold'>
          {title}
        </Typography>
        <Typography size='default' className='text-mono-color-medium'>
          {description}
        </Typography>
      </div>

      {showButton && (
        <Button full allowReadOnly onClick={handleCheckout}>
          Quero acesso completo
        </Button>
      )}
    </div>
  );
}
